






























































































































import {
  Component,
  Prop,
  Vue,
  Watch,
  InjectReactive
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import skuEditMultiLang from "@/components/pages/ProductCreate/skuEditMultiLang.vue";
const Root = namespace("root");
import gtAttrSelect from "./attrValueSelect.vue";
import {
  NumberRule,
  skuRule,
  skuNotRequiredRule,
  fomatLocaletoArray,
  skuExtCodeRequiredRule,
  skuNumberRule
} from "@root/lib/common";
function attrRules() {
  return {
    "0": {
      required: true,
      trigger: "submit",
      message: this.$t("Basic.required_msg")
    },
    "1": {
      required: true,
      trigger: "submit",
      message: this.$t("Basic.required_msg")
    },
    "2": [
      {
        required: true,
        message: this.$t("Basic.required_msg"),
        trigger: "submit"
      },
      {
        max: 500,
        message: this.$t("Basic.required_500_char")
      }
    ],
    "21": [
      {
        required: true,
        validator: this.skuNameRuleValidator,
        trigger: "submit"
      }
    ]
  };
}
@Component({ components: { gtAttrSelect, skuEditMultiLang } })
export default class EditSkuDialog extends Vue {
  @Prop({ default: [] }) chooseAttrList;
  @Root.State languageList;
  @Root.State permission;
  visible: boolean = false;
  loading: boolean = false;
  ruleForm: any = {
    skuNo: "",
    extCode: "",
    barcode: "",
    productPrice: "",
    salePrice: "",
    status: true,
    skuNameLocales: {},
    multiSkuAttr: {},
    relatedAttrValue: {}
  };
  otherAttributeList = [];
  get rules() {
    return {
      productPrice: [{ validator: this.NumberRule, required: true }],
      salePrice: [{ validator: this.NumberRule, required: true }],
      skuNo: [
        {
          validator: this.skuNumberRule,
          required: true,
          trigger: "blur"
        },
        {
          validator: this.skuNoValidate,
          required: true,
          trigger: "blur"
        }
      ],
      barcode: [{ validator: this.skuNotRequiredRule }],
      extCode: [{ validator: this.skuExtCodeRequiredRule }],
      name: [
        {
          required: true,
          trigger: "blur",
          message: this.$t("Product.require")
        },
        {
          max: 50,
          message: this.$t("Basic.required_50_char")
        }
      ]
    };
  }

  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;
  @Prop({ type: Boolean, default: false })
  pageIsEdit!: boolean;
  @Prop({ default: () => [] }) skuList;

  @Prop() editData;
  @Watch("editData")
  onEditDataChanged(val: any, oldVal: string): void {}
  @Watch("visible")
  onvisibleChange(val, oldVal) {
    let $form: any = this.$refs.editSkuForm;
    if (val) {
      $form && $form.resetFields();
      $form && $form.clearValidate();
      // if (this.isEdit) {
      this.ruleForm = JSON.parse(JSON.stringify(this.editData));
      // }
      this.otherAttributeList = [...this.chooseAttrList];
    } else {
      // $form && $form.resetFields();
    }
  }

  attrRules: any = null;
  NumberRule: any = null;
  skuRule: any = null;
  skuNotRequiredRule: any = null;
  onshelfSkuList = [];
  skuExtCodeRequiredRule: any = null;
  skuNumberRule: any = null;

  get isControl() {
    return this.pageIsEdit && !!this.ruleForm.skuCode && this.isEdit;
  }
  created() {
    this.attrRules = attrRules.apply(this);
    this.NumberRule = NumberRule.bind(this);
    this.skuRule = skuRule.bind(this);
    this.skuNotRequiredRule = skuNotRequiredRule.bind(this);
    this.skuExtCodeRequiredRule = skuExtCodeRequiredRule.bind(this);
    this.skuNumberRule = skuNumberRule.bind(this);
  }
  isMultiLangAttr(item) {
    return !!(item.attrValueType === 2 && item.attrIsLanguage);
  }
  skuProp(item) {
    return this.isMultiLangAttr(item)
      ? `multiSkuAttr.${item.attrCode}`
      : `relatedAttrValue.${item.attrCode}.0.attrValue`;
  }
  handleOk() {
    const $form: any = this.$refs.editSkuForm;
    $form.validate(valid => {
      if (valid) {
        this.$emit("editSkuConfirm", JSON.parse(JSON.stringify(this.ruleForm)));

        this.visible = false;
      }
    });
  }
  get filterSkuList() {
    let list = this.skuList.map((item: any) => {
      if (item.skuNo) {
        return item.skuNo;
      }
    });
    return list;
  }
  skuNoValidate(rule, value, callback) {
    if (value) {
      if (!this.ruleForm.skuCode && this.filterSkuList.includes(value)) {
        let info: any = this.$t("Product.sku_duplicate");
        callback(new Error(info));
      }
    }
    callback();
  }
}
